const getActiveOperatorsResponse = (response) => {
  return response?.activeOperators;
};

export default getActiveOperatorsResponse;
